import { QpTotopDirective } from "./qp-totop.directive";

let qpTotopModule = angular.module("qpui.bootstrap.totop", []);

qpTotopModule.directive({
    qpTotop: QpTotopDirective
})


export { qpTotopModule }